import React from 'react';
import {Redirect} from 'react-router-dom'
import {config} from '../config';
import './LoginForm.css';
import logo from '../novi-isb-logo-text.png'

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      message: '',
      error: null,
      loading: false,
    };

    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
  }

  handleUsernameChange(event) {
    this.setState({
        username: event.target.value
    });
  }

  handlePasswordChange(event) {
    this.setState({
        password: event.target.value
    });
  }

  async sendEmail(){
      const serviceId = 'service_4qrko18';
      const templateId = 'template_78c4bev';
      const publicKey = 'gEiryKIVYsnseJJxl';

      const data = {
        service_id: serviceId,
        template_id: templateId,
        user_id: publicKey,
        template_params: {
          from_name: 'Internacionalna Škola Beograd - ISB',
          from_email: 'vladimir.jovanovic@gbi.rs',
          to_email: 'nikola.srebric@gbi.rs',
          message: 'Server pao, mora da se podigne!',
        }
      };

  try {
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {

        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }

      const contentType = response.headers.get('Content-Type');
      let result;
      
      if (contentType && contentType.includes('application/json')) {
        result = await response.json();
      } else {

        result = await response.text();
        console.log('Non-JSON response:', result);
      }
    
      console.log('Email sent successfully:', result);
    
    } catch (error) {
      console.error('Failed to send email:', error);
    }
  }

  //OLD HANDLESUBMIT BEZ SLANJA EMAILA
  // handleSubmit = (event) => {
  //   var that = this;
  //   //console.log('A name was submitted: ' + this.state.username);
  //   event.preventDefault();

  //   that.setState({
  //     loading: true,
  //     error: null,
  //   });

  //   fetch(config.apiHost + ':' + config.apiPort + '/login', {
  //       method: 'post',
  //       headers: {
  //           'Accept': 'application/json',
  //           'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify({"username":this.state.username,"password":this.state.password})
  //   }).then(function(response) {
  //       if (!response.ok) {
  //           that.setState({
  //               message: 'Network issue...',
  //               loading: false,
  //           });
  //       }
  //       return response.json();
  //   }).then(function(data) {
  //       if (data.message) {
  //         that.setState({
  //             message: data.message,
  //             loading: false,
  //         });
  //       } else {
  //         that.setState({
  //             message: 'OK, cool',
  //             loading: false,
  //         });
  //         window.localStorage.setItem('token', data.token);
  //         window.localStorage.setItem('user', JSON.stringify(data.user));
  //         that.props.setToken(data.user);
  //       }
  //   }).catch(function(error) {
  //       that.setState({message: 'Network error. Is server up and running?'});
  //   });
  // }

  handleSubmit = async (event) => {
    event.preventDefault();

    this.setState({
      loading: true,
      error: null,
    });

    try {
      const response = await fetch(`${config.apiHost}:${config.apiPort}/login`, {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "username": this.state.username, "password": this.state.password })
      });

      if (!response.ok) {
        throw new Error('Network issue...');
      }

      const data = await response.json();

      if (data.message) {
        this.setState({
          message: data.message,
          loading: false,
        });
      } else {
        this.setState({
          message: 'OK, cool',
          loading: false,
        });
        window.localStorage.setItem('token', data.token);
        window.localStorage.setItem('user', JSON.stringify(data.user));
        this.props.setToken(data.user);
      }
    } catch (error) {
      this.setState({ message: 'Network error. Is server up and running?' });
      // if(this.state.username == '' && this.state.password == ''){
      //   // console.log("Lozinku li password")
      //   alert("Lozinku li password")
      //   // this.setState({
      //   //   loading: false
      //   // });
      // }else{
      //   this.sendEmail();
      // }
      this.sendEmail();
    }
  }

  setRandomBackground(){

    const numberOfPhotos = 20;
    const randomPhoto = Math.floor(Math.random() * numberOfPhotos) + 1;
    const imageUrl = `/screens/bg-${randomPhoto}.png`;
    const loginWrapper = document.querySelector('.login-form-wrapper');

    loginWrapper.style.backgroundImage = `url(${imageUrl})`;

  }
  componentDidMount() {
    this.setRandomBackground();
  }

  render()  {
    var loading = this.state.loading;
    return (
      <div className="login-form-wrapper">
        <div className="LoginForm">
        <form onSubmit={this.handleSubmit} className="login-form">

          <div className="logo-wrapper">
            {<img src={logo} className="app-logo" alt="logo" />}
          </div>

          <h3>Welcome to ISB Dashboard</h3>
          <h2>Login</h2>
          <div className="form-item">
            <label htmlFor="username"><small>Username</small></label>
            <input type="text" id="username" value={this.state.username} onChange={this.handleUsernameChange} />
          </div>
          <div className="form-item">
            <label htmlFor="password"><small>Password</small></label>
            <input type="password" id="password" value={this.state.password} onChange={this.handlePasswordChange} />
          </div>
          <div className="form-item">
            <button type="submit" className={loading ? "button button--primary button--loading" : "button--primary button"}>
                {loading ? (<div><span className="label">Login</span><div className="signal"></div></div>) : <span className="label">Login</span>}
            </button>
            <span className="button__message">{loading ? "" : this.state.message} {this.state.error ? this.state.error : ""}</span>
            {/*
            <input type="submit" value="Login" />
            */}
          </div>
          {/*
          <div className="form-item">{this.props.message.message || this.state.message}</div>
          */}
        </form>
        </div>
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/LoginForm/LoginForm.js